import { Component, OnInit } from "@angular/core";
import { FormGroup, Validators, FormBuilder } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";

import { DownloadService } from "../download.service";
import { ManifestType, DownloadKind, Manifest } from "./models";

@Component({
	selector: "app-download",
	templateUrl: "./download.component.html"
})
export class DownloadComponent implements OnInit {
	public downloadForm: FormGroup;
	public statusCode: number;
	public documentationUrl = "https://onlinehelp.opswat.com/safeconnect-enforcer";

	public data: Manifest[] = [];

	private manifestType: ManifestType;

	constructor(private formBuilder: FormBuilder, private downloadService: DownloadService, activatedRoute: ActivatedRoute) {
		downloadService.statusCodeDone$.subscribe((statusCode) => {
			this.statusCode = statusCode
		});

		const data = activatedRoute.snapshot.data as DownloadComponent.Data;
		this.manifestType = data.manifestType;
	}

	public ngOnInit() {
		this.downloadService
			.getManifest(this.manifestType)
			.then((manifests) => {
				for (const manifest of manifests) {
					this.data.push(manifest);
				}
				if (this.data.length === 1) {
					this.downloadForm.setValue(this.createFormValue());
				}
			})
			.catch((e) => {
				// TODO error handling
			});

		this.downloadForm = this.formBuilder.group(this.createFormValue());
	}

	public onSubmit() {
		this.downloadService.download(this.manifest);
	}

	public get kind(): DownloadKind {
		// when the user clicks a radio button to change the value, the value of the propeprty is the literal string value
		// when we have set it programatically, we get the array [value, Validators.required]
		const source = this.downloadForm.value.source;
		if (typeof source === "string") {
			return source as DownloadKind;
		} else {
			return source[0];
		}
	}

	public get manifest(): Manifest {
		if (!this.kind) {
			return undefined;
		}
		return this.data.find((manifest) => {
			return manifest.kind === this.kind;
		});
	}

	private createFormValue() {
		return {
			source: [
				this.data.length === 1 ? this.data[0].kind : "",
				Validators.required
			]
		}
	}
}

export namespace DownloadComponent {
	export interface Data {
		manifestType: ManifestType;
		documentationUrl: string;
	}
}
